import { CommonModule } from '@angular/common';
import { Component, computed, effect, input, signal } from '@angular/core';

import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';

import { ChartModule } from 'primeng/chart';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
    selector: 'app-doughnut-chart',
    imports: [CommonModule, ChartModule, ProgressSpinner],
    templateUrl: './doughnut-chart.component.html',
    styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent {
    loading = input<boolean>(false);
    salesChannelData = input<IFiltredDashboardResponse['salesChannel']['total']>();

    totalSales = computed(
        () => Number(this.salesChannelData()?.ota) + Number(this.salesChannelData()?.admin) + Number(this.salesChannelData()?.ibe)
    );

    chartOptions = {
        resposive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                align: 'start',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    font: {
                        size: 12
                    }
                }
            }
        },
        cutout: '60%'
    };

    chartData = signal({
        labels: ['OTA', 'Admin', 'IBE'],
        datasets: [
            {
                data: [0, 0, 0],
                backgroundColor: ['#8DD3C7', '#017A7D', '#02494C'],
                hoverBackgroundColor: ['#8DD3C7', '#017A7D', '#02494C']
            }
        ]
    });

    constructor() {
        effect(() => {
            this.updateChartData();
        });
    }

    updateChartData() {
        this.chartData.update((value) => ({
            ...value,
            datasets: [
                {
                    ...value?.datasets?.[0],
                    data: [
                        Number(this.salesChannelData()?.ota),
                        Number(this.salesChannelData()?.admin),
                        Number(this.salesChannelData()?.ibe)
                    ]
                }
            ]
        }));
    }
}
